<!-- <p>event-details works!</p> -->
<div class="main-events-div">

    @let SAPEnabled = checkFeature(AccountFeatures.SAP);

    @if (!wrongAccount) {
    <div class="title-div">
        <span style="font-size: large; font-weight: bolder;">
            @if (ruleEvent) {
            Rule Event Triggered by {{ruleEvent.AssetName}}
            }
            @else if (offlineEvent) {
            Offline Event Triggered by {{ offlineEvent.SensorName }}
            }
            @else if (webhookEvent) {
            Webhook Event Triggered by {{ webhookEvent.ClientWebhookID }}
            }
            @else if (deviationEvent) {
            Deviation Event Triggered by {{ deviationEvent.AssetName }} - {{deviationEvent.AssetDescription}}
            }
        </span>
        <span class="toolbar-spacer"></span>
        <button mat-raised-button (click)="back()" style="margin-bottom: 0.5em;" class="app-icon--back">
            <mat-icon />
            <span>Back</span>
        </button>
    </div>
    <div class="button-div">
        @if (asset) {
        <button mat-raised-button color="primary" [disabled]="!asset" (click)="goToAssetLocation()"
            class="app-icon--goto">
            <span>Go To Asset</span>
            <mat-icon />
        </button>
        }
        @if (webhookEvent) {
        <button mat-raised-button color="primary" [disabled]="!webhookEvent"
            routerLink="/setup/integration-management/{{OrganisationUID}}/integration/{{webhookEvent.WebhookUID}}"
            [queryParams]="{ webhooktypeid: webhookEvent.WebhookType}" class="app-icon--goto">
            <span>Go To Webhook</span>
            <mat-icon />
        </button>
        }
        @if (rule) {
        <button mat-raised-button color="primary"
            routerLink="/{{accountID}}/organisation/{{OrganisationUID}}/rules/{{rule.RuleID}}"
            style="margin-left: 0.5em;" class="app-icon--goto">
            <span>Go To Rule</span>
            <mat-icon />
        </button>
        }
        @if (rule && asset) {
        <button mat-raised-button style="margin-left: 0.5em;" color="primary" (click)="ViewRule(rule)">
            <span>View Rule</span>
            <mat-icon>visibility_on</mat-icon>
        </button>
        }
        @if (deviationEvent && asset) {
        <button mat-raised-button style="margin-left: 0.5em;" color="primary" (click)="viewDistribution()">
            <span>View Model</span>
            <mat-icon>visibility_on</mat-icon>
        </button>
        }
        @if (CMMSCase && SAPEnabled) {
        <button mat-raised-button style="margin-left: 0.5em;" color="primary" (click)="viewCMMS()">
            <span>view Case</span>
            <mat-icon>visibility_on</mat-icon>
        </button>
        }
        <span class="toolbar-spacer"></span>
        <button mat-raised-button (click)="goToEvents()" style="margin-bottom: 0.5em;">
            <mat-icon>notifications</mat-icon>
            <span>Events</span>
        </button>
    </div>

    <br>
    @if (showChart) {
    <div class="chart-div">
        <!-- <ejs-accordion>
            <e-accordionitems>
                <e-accordionitem [expanded]="true">
                    <ng-template #header>
                        <span>Chart</span>
                    </ng-template>
                    <ng-template #content>
                        <div>
                            <ng-container [ngTemplateOutlet]="eventChart" />
                        </div>
                    </ng-template>
                </e-accordionitem>
            </e-accordionitems>
        </ejs-accordion> -->
        <ng-container [ngTemplateOutlet]="eventDetals" />
        <div class="rule-chart-details">
            <ng-container [ngTemplateOutlet]="eventChart" />
        </div>
    </div>
    } @else {
    <ng-container [ngTemplateOutlet]="eventDetals" />
    }

    @if (deviationEvent) {
    <ng-container [ngTemplateOutlet]="modelDetals" />
    }

    <ng-container [ngTemplateOutlet]="commentsAccordion" />

    }
    @if (deviationEvent) {
    <div class="image-div">
        <img style="max-height: 60vh; max-width: 100%;" [src]="'data:image/png;base64,' + deviationEvent.EncodedImage"
            alt="Distribution Image" />
    </div>
    }
    @if (displayTimeline && !wrongAccount && eventType === 2){
    <ng-container [ngTemplateOutlet]="timelineAccordion" />
    }

    @if (wrongAccount) {
    <div class="wrong-account-div alignColumn">
        <span style="font-size: larger; font-weight: bold;">Wrong Account</span><br>
        <span>This event exists on a different account. If you have access to the correct account, please select that
            account to view the event.</span>
    </div>
    }
</div>

<ng-template #acknowledgeButtons>
    <div>
        @if (eventType !== 3) {
        <div class="acknowledge-button alignRow">
            @if (eventType === 1 || (Acknowledged && eventType === 4)) {
            <button mat-raised-button (click)="acknowledgeEvent(false)" [disabled]="Acknowledged">
                <mat-icon>done</mat-icon>
                <span>Acknowledge</span>
            </button>
            }
            @if (!Acknowledged && (eventType === 2 || eventType === 4)) {
            <button mat-raised-button (click)="acknowledgeEvent(true)">
                <mat-icon>done</mat-icon>
                <span>Acknowledge</span>
            </button>
            }
            @if (Acknowledged && eventType === 2) {
            <button mat-raised-button (click)="reopenEvent(true)">
                <mat-icon>restore</mat-icon>
                <span>Re-Open Event</span>
            </button>
            }
        </div>
        }
    </div>
</ng-template>

<ng-template #acknowledgeMessage>
    <div>
        @if (Acknowledged) {
        @if (eventType === 1 && offlineEvent && offlineEvent.AcknowledgedUser)
        {
        <span class="acknowledge-button alignRow">
            Acknowledged by {{ offlineEvent.AcknowledgedUser }}
            on {{ convertEpoch(offlineEvent.AcknowledgedTimestamp)}}
        </span>
        }
        @if (eventType === 2 && ruleEvent && ruleEvent.AcknowledgedUser)
        {
        <span class="acknowledge-button alignRow">
            Acknowledged by {{ ruleEvent.AcknowledgedUser }}
            on {{ convertEpoch(ruleEvent.AcknowledgedTimestamp) }}
        </span>
        }
        @if (eventType === 4 && deviationEvent && deviationEvent.AcknowledgedUser &&
        deviationEvent.AcknowledgedTimestamp)
        {
        <span class="acknowledge-button alignRow">
            Acknowledged by {{ deviationEvent.AcknowledgedUser }}
            on {{ convertEpoch(deviationEvent.AcknowledgedTimestamp) }}
        </span>
        }
        }
    </div>
</ng-template>

<ng-template #eventChart>
    <div class="alignRow alignColumn">
        @if (visibleStartDate && visibleEndDate) {
        <span matTooltip="{{getShortDate(visibleStartDate)}} - {{getShortDate(visibleEndDate)}}" class="hideoverflow">
            {{getShortDate(visibleStartDate)}} - {{getShortDate(visibleEndDate)}}
        </span>
        }
    </div>
    <div class="graph alignColumn alignRow">
        <!--  -->
        <ejs-chart #myChart2 id="myChart2" [primaryXAxis]='sensorXAxis' [zoomSettings]="zoomSettings"
            [legendSettings]='legend' [tooltip]='tooltipSettings' [crosshair]='crosshair' background="#FFFFFF"
            [border]="borderSettings" [selectionMode]='selectionMode' [palettes]='palette' [height]="chartHeight"
            [width]="chartWidth" (zoomComplete)="onZoom($event)" (scrollChanged)="onScroll($event)"
            (chartMouseDown)="checkClick($event)" (tooltipRender)="onTooltipRender($event)">
        </ejs-chart>
    </div>
    <div class="alignColumn alignRow">
        <app-duration-selector [(duration)]="strDuration" (durationChange)="selectTime($event)"></app-duration-selector>
    </div>

    @if (spinner) {
    <div class="local-spinner">
        <img src="https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/loading.gif"
            [attr.x-contenttype]="'image/gif'" alt="Loading..." />
    </div>
    }
</ng-template>

<ng-template #eventDetals>
    <div class="event-details">
        <div class="title">
            <span>Event Details</span>
        </div>
        <div class="details">
            @if (asset) {
            @if (asset.Name) {
            <div class="label">Asset:</div>
            <div>{{asset.Name }}</div>
            }

            @if (SAPEnabled) {
            @if (asset.FunctionalLocation || asset.ParentFunctionalLocation) {
            <div class="label">Asset Location:</div>
            <div>{{asset.FunctionalLocation != "" ? asset.FunctionalLocation : asset.ParentFunctionalLocation }}</div>
            }
            @if (asset.EquipmentCode) {
            <div class="label">Asset Code:</div>
            <div>{{asset.EquipmentCode }}</div>
            }
            }
            }

            @if (rule) {

            <div class="label">Rule Name:</div>
            <div>{{ rule.RuleDescription }}</div>

            @if (ruleEvent) {
            <div class="label">Timestamp:</div>
            <div>{{ convertEpoch(ruleEvent.TimeStamp) }}</div>

            @if (rule.RuleMessage) {
            <div class="label">Message:</div>
            <div>{{ rule.RuleMessage }}</div>
            }

            @if (rule.RuleDef) {
            <div class="label">Condition:</div>
            <div>{{ ruleEvent.RuleText }}</div>

            <div class="label">Values:</div>
            <div [innerHTML]="ruleValuesHtml"></div>
            }

            @if (ruleCondition) {
            <div class="label">Operator:</div>
            <div>{{ ruleCondition }}</div>
            }

            <div class="label">Trigger Time:</div>
            <div>{{ rule.TriggerTime }} Minutes</div>

            @if (SAPEnabled) {
            <div class="label">SAP Case:</div>
            @if (ruleEvent.CaseID) {<div><span>Yes</span></div>}
            @else {<div class="alignRow">
                <button mat-raised-button (click)="addCmmsCase()" [disabled]="!Acknowledged">
                    <mat-icon>add</mat-icon>
                    <span>Create New Case</span>
                </button>
            </div>}
            }

            }
            }

            @if (offlineEvent) {
            <div class="label">Timestamp:</div>
            <div>{{ convertEpoch(offlineEvent.TimeStamp) }}</div>

            <div class="label">Sensor Name:</div>
            <div>{{ offlineEvent.SensorName }}</div>

            <div class="label">Message:</div>
            <div>{{ offlineEvent.OfflineEventText }}</div>
            }

            @if (webhookEvent) {
            <div class="label">Timestamp:</div>
            <div>{{ convertEpoch(webhookEvent.TimeStamp) }}</div>

            <div class="label">Webhook:</div>
            <div>{{ webhookEvent.ClientWebhookID }}</div>

            <div class="label">Message:</div>
            <div>{{ webhookEvent.WebhookEventText }}</div>

            <div class="label">Webhook Description:</div>
            <div>{{ webhookEvent.Description }}</div>

            <div class="label">Event Type:</div>
            <div>{{ webhookEventType }}</div>
            }

            @if (deviationEvent) {

            <div class="label">Timestamp:</div>
            <div>{{ convertEpoch(deviationEvent.Timestamp) }}</div>

            <div class="label">DataPoint:</div>
            <div>{{ deviationEvent.DPTitle }}</div>

            <div class="label">Z-Score / Tolerance:</div>
            <div>{{ deviationEvent.ZScore }} / {{ deviationEvent.AcceptableDeviation }}</div>

            <div class="label">Message:</div>
            <div>
                @if (deviationEvent.Sensitivity === 50) {
                DataPoint <b>{{ deviationEvent.DPTitle }}</b> had an average Z-Score of
                <b>{{ deviationEvent.ZScore }}</b> which is above the Tolerance of
                <b>{{ deviationEvent.AcceptableDeviation }}</b>.
                }
                @else {
                <b>{{ deviationEvent.PercentageDeviated }}%</b> of the values for DataPoint
                <b>{{ deviationEvent.DPTitle }}</b> were above the Tolerance of
                <b>{{ deviationEvent.AcceptableDeviation }}</b> with an average Z-Score of
                <b>{{ deviationEvent.ZScore }}</b>.
                }
            </div>

            @if (checkFeature(AccountFeatures.SAP)) {
            <div class="label">SAP Case:</div>
            @if (deviationEvent.CaseID) {<div><span>Yes</span></div>}
            @else {<div class="alignRow">
                <button mat-raised-button (click)="addCmmsCase()" [disabled]="!Acknowledged">
                    <mat-icon>add</mat-icon>
                    <span>Create New Case</span>
                </button>
            </div>}
            }

            }

        </div>
        <hr>
        <div class="title-div alignRow">
            <ng-container [ngTemplateOutlet]="acknowledgeMessage"></ng-container>
            <span class="toolbar-spacer"></span>
            <ng-container [ngTemplateOutlet]="acknowledgeButtons"></ng-container>
        </div>

    </div>
</ng-template>

<ng-template #modelDetals>
    <br>
    @if (existingDistribution) {
    <div class="event-details">
        <div class="title">
            <span>Model Details</span>
        </div>
        <div class="details">
            <div class="label">Model Type:</div>
            <div>Normal Distribution</div>
            <div class="label">Created At:</div>
            <div>{{ convertEpoch(existingDistribution.CreatedAt) }}</div>
            <div class="label">Is this an active Model?</div>
            <div>
                <span><b>{{existingDistribution.MostRecent ? "Yes." : "No."}}</b>&nbsp;</span>
                <span>This Model&nbsp;</span>
                <span><b>{{existingDistribution.MostRecent ? "is" : "is not"}}</b>&nbsp;</span>
                <span>an active Model on this Asset.</span>
            </div>
        </div>
    </div>
    } @else {
    <div class="deleted-model alignColumn">
        <span>This model has been deleted since this event was created.</span>
    </div>
    }
</ng-template>

<ng-template #commentsAccordion>
    <br>
    <ejs-accordion style="border-radius: var(--default-border-radius);">
        <e-accordionitems>
            <e-accordionitem [expanded]="expanded">
                <ng-template #header>
                    <span>Comments ({{comments ? comments.length : 0}})</span>
                </ng-template>
                <ng-template #content>
                    <div><ng-container [ngTemplateOutlet]="commentsContent" /></div>
                </ng-template>
            </e-accordionitem>
        </e-accordionitems>
    </ejs-accordion>

    <ng-template #commentsContent>
        @if (comments && comments.length > 0) {
        <div>
            <div class="comment-info-div">
                <span>Comment Text</span>
                <span>Timestamp</span>
                <span>Added By</span>
            </div>
            @for (c of comments; track $index) {
            <div class="comment-div">
                <span>{{ c.CommentText }}</span>
                @if (c.Timestamp) {<span>{{ convertEpoch(c.Timestamp) }}</span>}
                @if (c.AddedByUserID) {<span>{{ c.AddedByUserID }}</span>}
            </div>
            }
        </div>
        }
        <div class="add-comment-button-div">
            <div class="add-button app-icon app-icon--add" (click)="addCommentNew()">
                <mat-icon /><span>Add Comment</span>
            </div>
        </div>
    </ng-template>

</ng-template>

<ng-template #timelineAccordion>
    <br>
    <ejs-accordion style="border-radius: var(--default-border-radius);">
        <e-accordionitems>
            <e-accordionitem>
                <ng-template #header>
                    <span>Timeline ({{Timeline ? Timeline.length : 0}})</span>
                </ng-template>
                <ng-template #content>
                    <div><ng-container [ngTemplateOutlet]="timelineContent" /></div>
                </ng-template>
            </e-accordionitem>
        </e-accordionitems>
    </ejs-accordion>

    <ng-template #timelineContent>
        @if (Timeline && Timeline.length > 0) {
        <div class="timeline-div alignColumn">
            <ejs-timeline orientation="Vertical" alignment="Before" [template]="customTemplate"
                cssClass="custom-timeline">
                <e-items>
                    @for (item of timelineItems; track $index) {
                    <e-item [dotCss]="item.dotCss" [content]="item.content" [oppositeContent]="item.oppositeContent" />
                    }
                </e-items>
                <ng-template #customTemplate let-data>
                    <div class='template-container'>
                        <div class="progress-line" [ngClass]="{'last': checkNotLast(data)}">
                            <div class="indicator alignRow alignColumn">
                                @if (data.item.dotCss != '') {
                                <mat-icon style="z-index: 1001;">
                                    @switch (data.item.dotCss) {
                                    @case ('1') {notifications_active}
                                    @case ('2') {done}
                                    @case ('3') {restore}
                                    @case ('4') {comment}
                                    @case ('5') {content_paste}
                                    @case ('6') {comment}
                                    @case ('7') {assignment_turned_in}
                                    @case ('8') {rules}
                                    @case ('9') {rules}
                                    @case ('10') {edit}
                                    @case ('12') {add_task}
                                    }
                                </mat-icon>
                                }
                            </div>
                        </div>
                        <div class="timeline-content">
                            <div class="content-container alignRow">
                                @switch (data.item.dotCss) {
                                @case ('1') {
                                @let RuleEvent = buildObject(data.item.content, data.item.dotCss);
                                <div class="timeline-element">
                                    <div class="timeline-title alignRow" (click)="goToTimelineItem(data.item)">
                                        <span>Event Created</span>
                                        <span class="toolbar-spacer"></span>
                                        <span>{{convertEpochString(data.item.oppositeContent)}}</span>
                                    </div>
                                    <br>
                                    <div class="timeline-item">
                                        <span class="timeline-item-title">Rule</span>
                                        <span class="timeline-item-title">Asset</span>
                                        <span class="timeline-item-title">Timestamp</span>
                                        <span>{{RuleEvent.RuleName}}</span>
                                        <span>{{RuleEvent.AssetName}}</span>
                                        <span>{{convertEpoch(RuleEvent.TimeStamp)}}</span>
                                    </div>
                                </div>
                                }
                                @case ('2') {
                                @let RuleEvent = buildObject(data.item.content, data.item.dotCss);
                                <div class="timeline-element">
                                    <div class="timeline-title alignRow" (click)="goToTimelineItem(data.item)">
                                        <span>Event Acknowledged</span>
                                        <span class="toolbar-spacer"></span>
                                        <span>{{convertEpochString(data.item.oppositeContent)}}</span>
                                    </div>
                                    <br>
                                    <div class="timeline-item">
                                        <span class="timeline-item-title">Rule</span>
                                        <span class="timeline-item-title">Asset</span>
                                        <span class="timeline-item-title">Timestamp</span>
                                        <span>{{RuleEvent.RuleName}}</span>
                                        <span>{{RuleEvent.AssetName}}</span>
                                        <span>{{convertEpoch(RuleEvent.TimeStamp)}}</span>
                                    </div>
                                </div>}
                                @case ('3') {
                                @let RuleEvent = buildObject(data.item.content, data.item.dotCss);
                                <div class="timeline-element">
                                    <div class="timeline-title alignRow" (click)="goToTimelineItem(data.item)">
                                        <span>Event Re-Opened</span>
                                        <span class="toolbar-spacer"></span>
                                        <span>{{convertEpochString(data.item.oppositeContent)}}</span>
                                    </div>
                                    <br>
                                    <div class="timeline-item">
                                        <span class="timeline-item-title">Rule</span>
                                        <span class="timeline-item-title">Asset</span>
                                        <span class="timeline-item-title">Timestamp</span>
                                        <span>{{RuleEvent.RuleName}}</span>
                                        <span>{{RuleEvent.AssetName}}</span>
                                        <span>{{convertEpoch(RuleEvent.TimeStamp)}}</span>
                                    </div>
                                </div>}
                                @case ('4') {
                                @let Comment = buildObject(data.item.content, data.item.dotCss);
                                <div class="timeline-element">
                                    <div class="timeline-title alignRow" (click)="goToTimelineItem(data.item)">
                                        <span>Event Comment Added</span>
                                        <span class="toolbar-spacer"></span>
                                        <span>{{convertEpochString(data.item.oppositeContent)}}</span>
                                    </div>
                                    <br>
                                    <div class="timeline-item">
                                        <span class="timeline-item-title">Comment Text</span>
                                        <span class="timeline-item-title">Added By</span>
                                        <span class="timeline-item-title">Timestamp</span>
                                        <span>{{Comment.CommentText}}</span>
                                        <span>{{Comment.AddedByUserID}}</span>
                                        <span>{{convertEpoch(Comment.Timestamp)}}</span>
                                    </div>
                                </div>}
                                @case ('5') {
                                @let Action = buildObject(data.item.content, data.item.dotCss);
                                <div class="timeline-element">
                                    <div class="timeline-title alignRow" (click)="goToTimelineItem(data.item)">
                                        <span>Action Created</span>
                                        <span class="toolbar-spacer"></span>
                                        <span>{{convertEpochString(data.item.oppositeContent)}}</span>
                                    </div>
                                    <br>
                                    <div class="timeline-item">
                                        <span class="timeline-item-title">Asset</span>
                                        <span class="timeline-item-title">Action Type</span>
                                        <span class="timeline-item-title">Details</span>
                                        <span>{{Action.AssetName}}</span>
                                        <span>{{getActionTypeFromValue(Action.ActionType)}}</span>
                                        <span>{{Action.Details}}</span>
                                    </div>
                                </div>}
                                @case ('6') {
                                @let Comment = buildObject(data.item.content, data.item.dotCss);
                                <div class="timeline-element">
                                    <div class="timeline-title alignRow" (click)="goToTimelineItem(data.item)">
                                        <span>Action Comment Added</span>
                                        <span class="toolbar-spacer"></span>
                                        <span>{{convertEpochString(data.item.oppositeContent)}}</span>
                                    </div>
                                    <br>
                                    <div class="timeline-item">
                                        <span class="timeline-item-title">Comment Text</span>
                                        <span class="timeline-item-title">Added By</span>
                                        <span class="timeline-item-title">Timestamp</span>
                                        <span>{{Comment.CommentText}}</span>
                                        <span>{{Comment.AddedByUserID}}</span>
                                        <span>{{convertEpoch(Comment.Timestamp)}}</span>
                                    </div>
                                </div>}
                                @case ('7') {
                                @let Action = buildObject(data.item.content, data.item.dotCss);
                                <div class="timeline-element">
                                    <div class="timeline-title alignRow" (click)="goToTimelineItem(data.item)">
                                        <span>Action Completed</span>
                                        <span class="toolbar-spacer"></span>
                                        <span>{{convertEpochString(data.item.oppositeContent)}}</span>
                                    </div>
                                    <br>
                                    <div class="timeline-item">
                                        <span class="timeline-item-title">Asset</span>
                                        <span class="timeline-item-title">Action Type</span>
                                        <span class="timeline-item-title">Details</span>
                                        <span>{{Action.AssetName}}</span>
                                        <span>{{getActionTypeFromValue(Action.ActionType)}}</span>
                                        <span>{{Action.Details}}</span>
                                    </div>
                                </div>}
                                @case ('8') {
                                @let Rule = buildObject(data.item.content, data.item.dotCss);
                                <div class="timeline-element">
                                    <div class="timeline-title alignRow" (click)="goToTimelineItem(data.item)">
                                        <span>Rule Disabled</span>
                                        <span class="toolbar-spacer"></span>
                                        <span>{{convertEpochString(data.item.oppositeContent)}}</span>
                                    </div>
                                    <br>
                                    <div class="timeline-item">
                                        <span class="timeline-item-title">Rule</span>
                                        <span></span>
                                        <span></span>
                                        <span>{{Rule.RuleDescription}}</span>
                                        <span></span>
                                        <span></span>
                                    </div>
                                </div>}
                                @case ('9') {
                                @let Rule = buildObject(data.item.content, data.item.dotCss);
                                <div class="timeline-element">
                                    <div class="timeline-title alignRow" (click)="goToTimelineItem(data.item)">
                                        <span>Rule Re-Enabled</span>
                                        <span class="toolbar-spacer"></span>
                                        <span>{{convertEpochString(data.item.oppositeContent)}}</span>
                                    </div>
                                    <br>
                                    <div class="timeline-item">
                                        <span class="timeline-item-title">Rule</span>
                                        <span></span>
                                        <span></span>
                                        <span>{{Rule.RuleDescription}}</span>
                                        <span></span>
                                        <span></span>
                                    </div>
                                </div>}
                                @case ('10') {
                                @let RuleEdit = buildObject(data.item.content, data.item.dotCss);
                                <div class="timeline-element">
                                    <div class="timeline-title alignRow" (click)="goToTimelineItem(data.item)">
                                        <span>Rule Changed</span>
                                        <span class="toolbar-spacer"></span>
                                        <span>{{convertEpochString(data.item.oppositeContent)}}</span>
                                    </div>
                                    <br>
                                    <div class="timeline-item">
                                        <span class="timeline-item-title">Previous Conditions</span>
                                        <span class="timeline-item-title">New Conditions</span>
                                        <span class="timeline-item-title">Changed By</span>
                                        <span>{{RuleEdit.PreviousConditions}}</span>
                                        <span>{{RuleEdit.NewConditions}}</span>
                                        <span>{{RuleEdit.UserID}}</span>
                                    </div>
                                </div>}
                                @case ('12') {
                                @let CaseFile = buildObject(data.item.content, data.item.dotCss);
                                <div class="timeline-element">
                                    <div class="timeline-title alignRow" (click)="goToTimelineItem(data.item)">
                                        <span>CMMS Case Created</span>
                                        <span class="toolbar-spacer"></span>
                                        <span>{{convertEpochString(data.item.oppositeContent)}}</span>
                                    </div>
                                    <br>
                                    <div class="timeline-item">
                                        <span class="timeline-item-title">ID</span>
                                        <span class="timeline-item-title">Description</span>
                                        <span class="timeline-item-title">Trigger</span>
                                        <span>{{CaseFile.Id}}</span>
                                        <span>{{CaseFile.Description}}</span>
                                        <span>{{CaseFile.Trigger}}</span>
                                    </div>
                                </div>}
                                }
                            </div>
                        </div>
                    </div>
                </ng-template>
            </ejs-timeline>
        </div>
        }
    </ng-template>
</ng-template>